import '/assets/styles/layouts/raw.scss';

const RawLayout = ({ children, pageClass }) => {
	return (
		<div className={`page layout-raw ${pageClass ? 'page-' + pageClass : ''}`}>{children}</div>
	);
};

export default RawLayout;
